<template>
  <div class="terms-of-use">
    <section v-for="section in sections" :key="section.heading" class="terms-of-use__section">
      <h3 class="terms-of-use__heading">{{ section.heading }}</h3>
      <p v-for="(paragraph, index) in section.paragraphs" :key="index" class="terms-of-use__text">
        {{ paragraph }}
      </p>
      <p v-if="section.intro" class="terms-of-use__text">{{ section.intro }}</p>
      <ul v-if="section.bullets?.length" class="terms-of-use__list">
        <li v-for="(bullet, index) in section.bullets" :key="index">{{ bullet }}</li>
      </ul>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

type TermsSection = {
  heading: string;
  paragraphs?: string[];
  intro?: string;
  bullets?: string[];
};

const { tm } = useI18n();

function asParagraphs(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string');
  }
  return typeof value === 'string' && value ? [value] : [];
}

const sections = computed(() => {
  const body = tm('certificateDetails.termsBody');
  if (!Array.isArray(body)) {
    return [];
  }
  return body.map((section) => {
    const item = section as TermsSection & { paragraphs?: string[] | string };
    return {
      ...item,
      paragraphs: asParagraphs(item.paragraphs),
    };
  });
});
</script>

<style scoped>
.terms-of-use__section {
  margin-bottom: 20px;
}

.terms-of-use__heading {
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px;
  color: #111827;
}

.terms-of-use__text {
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  line-height: 1.55;
  color: #374151;
  margin: 0 0 10px;
}

.terms-of-use__list {
  margin: 0 0 10px;
  padding-left: 20px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  line-height: 1.55;
  color: #374151;
}

.terms-of-use__list li {
  margin-bottom: 6px;
}
</style>
